/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_REPORTS_META_DATA,
  CREATE_PURCHASE_INVOICE,
  UPDATE_PURCHASE_INVOICE,
  DELETE_PURCHASE_INVOICE,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PURCHASE_INVOICE_CATEGORY,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY,
  LOAD_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS,
  LOAD_REPORTS_DASHBOARD_TRANSACTION,
  LOAD_PURCHASE_REPORT_TOTAL,
  LOAD_TOTAL_REPORT_PAID,
  LOAD_TOTAL_REPORT_UNPAID,
  LOAD_PURCHASE_INVOICE_BARCODE,
  LOAD_LEDGER_STATEMENT_REPORT,
  LOAD_PURCHASE_INVOICE_REPORT,
  LOAD_STOCK_REPORT_DETAILS,
  LOAD_ITEMS_QUANTITY_REPORT,
  LOAD_STOCK_SUMMARY_REPORT_DETAILS,
  LOAD_SALES_ITEMS_QUANTITY_REPORT,
  LOAD_SALES_FILTER_REPORT,
  LOAD_SALES_RETURN_REPORT,
  LOAD_SALES_RETURN_ITEMS_REPORT,
  LOAD_SALES_SUMMARY_REPORT,
  LOAD_PURCHASE_SUMMARY_REPORT,
  LOAD_BILL_STATUS_META_DATA,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT,
  LOAD_PROFIT_REPORT_LIST,
  LOAD_TICKETING_DETAILS,
  LOAD_TICKET_REPLY_LIST,
} from "./constants";

import {
  loadPurchaseInvoice,
  loadPurchaseInvoiceSuccess,
  loadPurchaseInvoiceError,
  loadManageOrganizationList,
  loadManageOrganizationListSuccess,
  loadManageOrganizationListError,
  createPurchaseInvoiceListSuccess,
  createPurchaseInvoiceListError,
  updatePurchaseInvoiceListSuccess,
  updatePurchaseInvoiceListError,
  deletePurchaseInvoiceListSuccess,
  deletePurchaseInvoiceListError,
  loadPurchaseInvoiceRecordsMetaDataError,
  loadPurchaseInvoiceRecordsMetaDataSuccess,
  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,
  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,
  loadPartyVendorAddress,
  loadPartyVendorAddressSuccess,
  loadPartyVendorAddressError,
  createPartyVendorAddressSuccess,
  createPartyVendorAddressError,
  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,
  loadPurchaseTotal,
  loadPurchaseTotalSuccess,
  loadPurchaseTotalError,
  loadTotalPaid,
  loadTotalPaidSuccess,
  loadTotalPaidError,
  loadTotalUnPaid,
  loadTotalUnPaidSuccess,
  loadTotalUnPaidError,
  loadPurchaseBarcode,
  loadPurchaseBarcodeSuccess,
  loadPurchaseBarcodeError,
  loadLedgerStatmentList,
  loadLedgerStatmentListSuccess,
  loadLedgerStatmentListError,
  loadItemQuantityReport,
  loadItemQuantityReportSuccess,
  loadItemQuantityReportError,
  loadStockSummaryReportList,
  loadStockSummaryReportListSuccess,
  loadStockSummaryReportListError,
  loadSalesItemQtyReportSuccess,
  loadSalesItemQtyReportError,
  loadSalesItemQtyReport,
  loadSalesFiltersReport,
  loadSalesFiltersReportSuccess,
  loadSalesFiltersReportError,
  loadSalesReturnReport,
  loadSalesReturnReportSuccess,
  loadSalesReturnReportError,
  loadSalesReturnItemsReport,
  loadSalesReturnItemsReportSuccess,
  loadSalesReturnItemsReportError,
  loadSalesSummaryReport,
  loadSalesSummaryReportSuccess,
  loadSalesSummaryReportError,
  loadPurchaseSummaryReport,
  loadPurchaseSummaryReportSuccess,
  loadPurchaseSummaryReportError,
  loadBillStatusMetaDataSuccess,
  loadBillStatusMetaDataError,
  loadPartyWiseOutstandingReport,
  loadPartyWiseOutstandingReportSuccess,
  loadPartyWiseOutstandingReportError,
  loadProfitLossReportList,
  loadProfitLossReportListSuccess,
  loadProfitLossReportListError,
  loadTicketingDetails,
  loadTicketingDetailsSuccess,
  loadTicketingDetailsError,
  loadTicketReplyList,
  loadTicketReplyListSuccess,
  loadTicketReplyListError,
} from "./actions";

import {
  loadPurchaseInvoiceDetails,
  createPurchaseInvoiceDetails,
  loadManageOrganizationDetails,
  updatePurchaseInvoiceDetails,
  deletePurchaseInvoiceDetails,
  loadRecordsMetaData,
  loadPartiesTransactionDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadPartyVendorAddressDetails,
  createPartyVendorAddressDetails,
  loadDashboardTransactionsDetails,
  loadTotalPaidDetails,
  loadTotalUnPaidDetails,
  loadTotalSalesDetails,
  loadPurchaseBarcodeDetails,
  loadLedgerStatmentDetails,
  loadItemsQuantityReportDetails,
  loadStockSummaryReportDetails,
  loadSalesItemsQuantityReportDetails,
  loadSalesFiltersReportDetails,
  loadSalesReturnReportDetails,
  loadSalesReturnItemsReportDetails,
  loadSalesSummaryReportDetails,
  loadPurchaseSummaryReportDetails,
  loadBillStatusMetaData,
  loadPartyWiseOutstandingReportDetails,
  loadProfitReportDetails,
  loadTicketingDetailsReport,
  loadTicketingReplyDetails,
} from "./remotes";
import { isEmpty } from "lodash";

function* loadPurchaseInvoiceSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_INVOICE_REPORT),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPurchaseInvoice(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPurchaseInvoiceDetails, salesInvoiceList);

        if (result) {
          yield put(loadPurchaseInvoiceSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPurchaseInvoiceError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadLedgerStatmentListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_LEDGER_STATEMENT_REPORT),
    });

    const { explicitLoad } = load;
    const { partyLedger } = explicitLoad || {};
    yield put(loadLedgerStatmentList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadLedgerStatmentDetails, partyLedger);

        if (result) {
          yield put(loadLedgerStatmentListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadLedgerStatmentListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartyWiseOutstandingReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTY_WISE_OUTSTANDING_REPORT),
    });

    const { explicitLoad } = load;
    const { partyLedger } = explicitLoad || {};
    yield put(loadPartyWiseOutstandingReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPartyWiseOutstandingReportDetails,
          partyLedger
        );

        if (result) {
          yield put(loadPartyWiseOutstandingReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartyWiseOutstandingReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPurchaseBarcodeSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_INVOICE_BARCODE),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPurchaseBarcode(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPurchaseBarcodeDetails, salesInvoiceList);

        if (result) {
          yield put(loadPurchaseBarcodeSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPurchaseBarcodeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDashboardTransactionsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_REPORTS_DASHBOARD_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadDashboardTransactions(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadDashboardTransactionsDetails,
          transactionsList
        );

        if (result) {
          yield put(loadDashboardTransactionsSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDashboardTransactionsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPurchaseTotalDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_REPORT_TOTAL),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadPurchaseTotal(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalSalesDetails, transactionsList);

        if (result) {
          yield put(loadPurchaseTotalSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPurchaseTotalError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTotalPaidSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TOTAL_REPORT_PAID),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadTotalPaid(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalPaidDetails, transactionsList);

        if (result) {
          yield put(loadTotalPaidSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTotalPaidError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadTotalUnPaidSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TOTAL_REPORT_UNPAID),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadTotalUnPaid(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalUnPaidDetails, transactionsList);

        if (result) {
          yield put(loadTotalUnPaidSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTotalUnPaidError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartyVendorAddressSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTY_VENDOR_ADDRESS),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPartyVendorAddress(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPartyVendorAddressDetails,
          salesInvoiceList
        );

        if (result) {
          yield put(loadPartyVendorAddressSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartyVendorAddressError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartyVendorAddressSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PARTY_VENDOR_ADDRESS),
    });

    const { partyAddress } = create || {};

    if (create) {
      try {
        const result = yield call(
          createPartyVendorAddressDetails,
          partyAddress
        );
        if (result) {
          yield put(createPartyVendorAddressSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartyVendorAddressError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesTransactionSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPartiesTransaction(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPartiesTransactionDetails,
          salesInvoiceList
        );

        if (result) {
          yield put(loadPartiesTransactionSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesTransactionError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PURCHASE_INVOICE),
    });

    const { salesInvoiceList } = create || {};

    if (create) {
      try {
        const result = yield call(
          createPurchaseInvoiceDetails,
          salesInvoiceList
        );
        if (result) {
          yield put(createPurchaseInvoiceListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPurchaseInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePartiesSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_PURCHASE_INVOICE),
    });
    const { salesInvoiceList } = update || {};

    if (update) {
      try {
        const result = yield call(
          updatePurchaseInvoiceDetails,
          salesInvoiceList
        );
        if (result) {
          yield put(updatePurchaseInvoiceListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updatePurchaseInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_PURCHASE_INVOICE),
    });
    const { salesInvoiceList } = create || {};

    if (create) {
      try {
        const result = yield call(
          deletePurchaseInvoiceDetails,
          salesInvoiceList
        );
        if (result) {
          yield put(deletePurchaseInvoiceListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deletePurchaseInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesCategorySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_INVOICE_CATEGORY),
    });
    const { explicitLoad } = load;
    const { categoryList } = explicitLoad || {};
    yield put(loadPartiesCategory(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesCategoryDetails, categoryList);

        if (result) {
          yield put(loadPartiesCategorySuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesCategoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesCategorySaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY),
    });
    const { categoryList } = create || {};

    if (create) {
      try {
        const result = yield call(createPartiesCategoryDetails, categoryList);
        if (result) {
          yield put(createPartiesCategoryListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartiesCategoryListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//stock report
function* loadManageOrganizationDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_STOCK_REPORT_DETAILS),
    });

    const { explicitLoad } = load;
    const { orgList } = explicitLoad || {};
    yield put(loadManageOrganizationList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadManageOrganizationDetails, orgList);

        if (result) {
          yield put(loadManageOrganizationListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadManageOrganizationListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//stock report
function* loadStockSummaryReportDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_STOCK_SUMMARY_REPORT_DETAILS),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadStockSummaryReportList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadStockSummaryReportDetails, stockDetails);

        if (result) {
          yield put(loadStockSummaryReportListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadStockSummaryReportListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//profit report
function* loadProfitReportDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PROFIT_REPORT_LIST),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadProfitLossReportList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadProfitReportDetails, stockDetails);

        if (result) {
          yield put(loadProfitLossReportListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadProfitLossReportListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//item report
function* loadItemQuantityReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ITEMS_QUANTITY_REPORT),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadItemQuantityReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadItemsQuantityReportDetails, stockDetails);

        if (result) {
          yield put(loadItemQuantityReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadItemQuantityReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//sales qty report
function* loadSalesItemQuantityReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_ITEMS_QUANTITY_REPORT),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadSalesItemQtyReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadSalesItemsQuantityReportDetails,
          stockDetails
        );

        if (result) {
          yield put(loadSalesItemQtyReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSalesItemQtyReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//sales report
function* loadSalesFilterReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_FILTER_REPORT),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadSalesFiltersReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesFiltersReportDetails, stockDetails);

        if (result) {
          yield put(loadSalesFiltersReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSalesFiltersReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//sales report
function* loadSalesSummaryReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_SUMMARY_REPORT),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadSalesSummaryReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesSummaryReportDetails, stockDetails);

        if (result) {
          yield put(loadSalesSummaryReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSalesSummaryReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//sales report
function* loadPurchaseSummaryReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_SUMMARY_REPORT),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadPurchaseSummaryReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPurchaseSummaryReportDetails,
          stockDetails
        );

        if (result) {
          yield put(loadPurchaseSummaryReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPurchaseSummaryReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//sales return report
function* loadSalesReturnReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_RETURN_REPORT),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadSalesReturnReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesReturnReportDetails, stockDetails);

        if (result) {
          yield put(loadSalesReturnReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSalesReturnReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//sales return items report
function* loadTicketingDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TICKETING_DETAILS),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadTicketingDetails(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTicketingDetailsReport, stockDetails);

        if (result) {
          yield put(loadTicketingDetailsSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTicketingDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTicketingReplySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TICKET_REPLY_LIST),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadTicketReplyList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTicketingReplyDetails, stockDetails);

        if (result) {
          yield put(loadTicketReplyListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTicketReplyListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
//sales return items report
function* loadSalesReturnItemsReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_RETURN_ITEMS_REPORT),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadSalesReturnItemsReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadSalesReturnItemsReportDetails,
          stockDetails
        );

        if (result) {
          yield put(loadSalesReturnItemsReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSalesReturnItemsReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPurchaseInvoiceMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_REPORTS_META_DATA),
    });
    const userName = localStorage.getItem("authData");

    const userNameDetails = JSON.parse(userName);

    const userInfoDetails = !isEmpty(userNameDetails)
      ? userNameDetails.user.organizations[0].organizationId
      : "";
    try {
      const barcode = yield call(
        loadRecordsMetaData,
        "getdropdownbarcodedata",
        "post",
        {
          organizationId: userInfoDetails,
        }
      );
      // const state = yield call(loadRecordsMetaData, "getstate", "post");

      let recordsMetaData = {
        barcodeOptions:
          (barcode &&
            barcode &&
            barcode.length > 0 &&
            barcode.map((c) =>
              Object.assign(
                {},
                {
                  label: c.barcodeNo,
                  value: c.barcodeNo,
                }
              )
            )) ||
          [],
        // stateOptions:
        //   (state &&
        //     state &&
        //     state.length > 0 &&
        //     state.map((c) =>
        //       Object.assign(
        //         {},
        //         {
        //           label: c.stateName,
        //           shortCode: c.shortCode,
        //           value: c._id,
        //         }
        //       )
        //     )) ||
        //   [],
        // currencyOptions:
        //   (currency &&
        //     currency &&
        //     currency.length > 0 &&
        //     currency.map((c) =>
        //       Object.assign(
        //         {},
        //         {
        //           label: c.currencyName,
        //           shortCode: c.shortCode,
        //           value: c._id,
        //         }
        //       )
        //     )) ||
        //   [],
      };

      yield put(loadPurchaseInvoiceRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadPurchaseInvoiceRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

function* loadBillStatusMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_BILL_STATUS_META_DATA),
    });

    try {
      const billStatus = yield call(
        loadBillStatusMetaData,
        "getbillstatus",
        "post"
      );
      // const state = yield call(loadRecordsMetaData, "getstate", "post");

      let recordsMetaData = {
        billStatusOptions:
          (billStatus &&
            billStatus &&
            billStatus.length > 0 &&
            billStatus.map((c) =>
              Object.assign(
                {},
                {
                  label: c.statusName,
                  value: c.billStatusNo,
                }
              )
            )) ||
          [],
      };

      yield put(loadBillStatusMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadBillStatusMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadPurchaseInvoiceSaga(),
    loadStockSummaryReportDetailsSaga(),
    loadProfitReportDetailsSaga(),
    loadBillStatusMetaDataSaga(),
    loadPurchaseBarcodeSaga(),
    loadLedgerStatmentListSaga(),
    deletePartiesSaga(),
    updatePartiesSaga(),
    createPartiesSaga(),
    loadTicketingReplySaga(),
    loadPurchaseInvoiceMetaDataSaga(),
    loadPartiesTransactionSaga(),
    createPartiesCategorySaga(),
    createPartyVendorAddressSaga(),
    loadPartyVendorAddressSaga(),
    loadPartiesCategorySaga(),
    loadDashboardTransactionsSaga(),
    loadPurchaseTotalDetailsSaga(),
    loadTotalPaidSaga(),
    loadTotalUnPaidSaga(),
    loadManageOrganizationDetailsSaga(),
    loadTicketingDetailsSaga(),
    loadItemQuantityReportSaga(),
    loadSalesItemQuantityReportSaga(),
    loadSalesFilterReportSaga(),
    loadSalesSummaryReportSaga(),
    loadPurchaseSummaryReportSaga(),
    loadPartyWiseOutstandingReportSaga(),
    loadSalesReturnReportSaga(),
    loadSalesReturnItemsReportSaga(),
  ]);
}
